import React from "react";
import getGoogleMapsLink from "./../../utilities/maps";
import {
  formatDateString,
  sortDateString
} from "./../../utilities/datesFormatter";

export const linkToGoogleMaps = (tableInfo, event) => {
  if (tableInfo && tableInfo.column) {
    let ubicacion;
    switch (tableInfo.column.id) {
      case "Inicio":
        ubicacion = tableInfo.original.UbicacionInicio;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      case "Fin":
        ubicacion = tableInfo.original.UbicacionFin;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      case "Mapa":
        ubicacion = tableInfo.original;
        window.open(
          getGoogleMapsLink(ubicacion.Latitud, ubicacion.Longitud, "_blank")
        );
        break;
      default:
        break;
    }
  }
};

export const buildCycleTableColumns = (
  lang,
  temperatureUnit = "C",
  metricUnit = "Km"
) => {
  const cyclesTableColumns = [
    {
      Header: lang.Inicio,
      accessor: "Inicio", // String-based value accessors!
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {props.value}
        </span>
      )
    },
    {
      Header: lang.Fin,
      accessor: "Fin",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {props.value}
        </span>
      )
    },
    {
      Header: `${lang.Minima} °${temperatureUnit}`,
      accessor: "TemperaturaMinima"
    },
    {
      Header: `${lang.Maxima} °${temperatureUnit}`,
      accessor: "TemperaturaMaxima"
    },
    {
      Header: `${lang.Promedio} °${temperatureUnit}`,
      accessor: "TemperaturaPromedio"
    },
    {
      Header: lang.AperturaPuertaPrincipal,
      accessor: "AperturasPuertaPrincipal"
    },
    {
      Header: lang.AperturaPuertaLateral,
      accessor: "AperturasPuertaLateral"
    },
    {
      Header: `${lang.Distancia} ${metricUnit}`,
      accessor: "DistanciaRecorrida"
    },
    {
      Header: lang.TiempoEnRefrigeracion,
      accessor: "TiempoRefrigeracion",
      sortMethod: sortDateString
    }
  ];

  return cyclesTableColumns;
};

export const buildOutOfRangesTableColumns = (lang, temperatureUnit = "C") => {
  const outOfRangesTableColumns = [
    {
      Header: lang.Inicio,
      accessor: "Inicio",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {props.value}
        </span>
      )
    },
    {
      Header: lang.Fin,
      accessor: "Fin",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {props.value}
        </span>
      )
    },
    {
      Header: `${lang.Rango} °${temperatureUnit}`,
      accessor: "Rango",
      id: "rango",
      Cell: props => (
        <span className="number">{`${props.value.LimiteInferior} ~ ${
          props.value.LimiteSuperior
        }`}</span>
      )
    },
    {
      Header: `${lang.Minima} °${temperatureUnit}`,
      accessor: "TemperaturaMinima"
    },
    {
      Header: `${lang.Maxima} °${temperatureUnit}`,
      accessor: "TemperaturaMaxima"
    },
    {
      Header: `${lang.Promedio} °${temperatureUnit}`,
      accessor: "TemperaturaPromedio"
    },
    {
      Header: lang.TiempoFueraRango,
      accessor: "TiempoFueraRango",
      sortMethod: sortDateString
    }
  ];

  return outOfRangesTableColumns;
};

export const buildEventsTableColumns = lang => {
  const eventsColumns = [
    {
      Header: lang.Fecha,
      accessor: "FechaEvento"
    },
    {
      Header: lang.Evento,
      accessor: "NombreEvento"
    },
    {
      Header: lang.Icono,
      accessor: "ImagenUrl",
      Cell: props => <img src={props.value} alt="" />
    },
    {
      Header: lang.Mapa,
      accessor: "Mapa",
      Cell: props => (
        <span className="link" onClick={linkToGoogleMaps.bind(null, props)}>
          {lang.Mapa}
        </span>
      )
    }
  ];

  return eventsColumns;
};



// WEBPACK FOOTER //
// ./src/containers/Temp/builders.js